exports.components = {
  "component---src-components-browse-game-guides-js": () => import("./../../../src/components/browse-game-guides.js" /* webpackChunkName: "component---src-components-browse-game-guides-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-game-guides-mdx-slug-js": () => import("./../../../src/pages/game_guides/{mdx.slug}.js" /* webpackChunkName: "component---src-pages-game-guides-mdx-slug-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

